const cards = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20artistic%20manga%20style%20illustration%20of%20a%20digital%20tablet%20displaying%20a%20comic%20page%20on%20a%20cozy%20desk%2C%20soft%20golden%20lamp%20light%2C%20notebook%20and%20coffee%20cup%20nearby%2C%20warm%20cream%20background%2C%20clean%20aesthetic%20composition%2C%20modern%20reading%20lifestyle&width=600&height=400&seq=cards-01-2026&orientation=landscape",
    title: '如何高效追更不遗漏',
    desc: '利用女神漫画网订阅功能，为每部连载设置专属提醒，更新第一时间自动推送，再也不用隔三差五刷新页面。',
    tag: '追更指南',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20illustration%20of%20a%20smartphone%20screen%20showing%20a%20manga%20reader%20app%20interface%20with%20vertical%20scrolling%20comic%20panels%2C%20on%20a%20wooden%20table%20with%20warm%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20soft%20cream%20and%20beige%20tones&width=600&height=400&seq=cards-02-2026&orientation=landscape",
    title: '下拉式追更体验详解',
    desc: '告别翻页跳转的割裂感，下拉式阅读让你像刷社交媒体一样流畅追漫，沉浸感大幅提升，韩漫日漫国漫全部适配。',
    tag: '使用技巧',
  },
  {
    img: "https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20of%20three%20manga%20books%20stacked%20on%20a%20table%20next%20to%20a%20warm%20glowing%20reading%20lamp%2C%20soft%20shadows%2C%20cozy%20evening%20atmosphere%2C%20cream%20and%20golden%20color%20palette%2C%20clean%20simple%20composition&width=600&height=400&seq=cards-03-2026&orientation=landscape",
    title: '免费全集资源哪里找',
    desc: '女神漫画网持续收录各大平台免费全集资源，从热门韩漫到经典日漫、原创国漫，无需付费即可畅读完整内容。',
    tag: '资源导航',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20illustration%20of%20a%20calendar%20with%20manga%20update%20markers%20and%20colorful%20sticky%20notes%20on%20a%20desk%2C%20soft%20morning%20light%2C%20organized%20creative%20workspace%2C%20warm%20cream%20and%20gentle%20pastel%20tones%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=cards-04-2026&orientation=landscape",
    title: '追更日历使用攻略',
    desc: '通过追更日历功能，一目了然查看本周所有连载漫画的更新时间，合理安排追更计划，不错过任何一部心头好。',
    tag: '追更计划',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20community%20of%20manga%20fans%20discussing%20comics%20around%20a%20table%2C%20thought%20bubbles%20with%20manga%20style%20elements%2C%20cozy%20cafe%20atmosphere%2C%20soft%20warm%20lighting%2C%20cream%20and%20terracotta%20tones&width=600&height=400&seq=cards-05-2026&orientation=landscape",
    title: '追更社群互动玩法',
    desc: '加入女神漫画网读者社群，和你追同一部漫画的伙伴一起讨论剧情、预测后续发展，追更路上不再孤单。',
    tag: '社群互动',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            追更指南
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            用好这些功能，让你的追更体验更上一层楼
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((item, idx) => (
            <a
              key={idx}
              href="#app"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-[860px] mx-auto">
          {cards.slice(3).map((item, idx) => (
            <a
              key={idx + 3}
              href="#app"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-2/5 aspect-[3/2] sm:aspect-auto overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="sm:w-3/5 p-4">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-2">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}